var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MglMap',{attrs:{"accessToken":_vm.accessToken,"mapStyle":_vm.mapStyle,"center":_vm.coordinates,"zoom":_vm.zoom,"showCompass":false}},[_c('MglMarker',{attrs:{"coordinates":_vm.coordinates,"color":"red"}},[_c('MglPopup',[_c('VCard',[_c('div',[_vm._v("Unimarc Los Militares")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }